/* eslint-env node, browser */
'use strict'

module.exports = function () {
  var self = this

  self.instances.forEach(function (combokeys) {
    combokeys.reset()
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/combokeys/Combokeys/reset.js
// module id = 538
// module chunks = 0